// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router";
import store from "./store";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "./plugins/vuetify-money.js";
import Gravatar from "vue-gravatar";
import VueTour from "vue-tour";

Vue.component("v-gravatar", Gravatar);

// to use axios globally
import Axios from "axios";
Vue.prototype.$http = Axios;

// vue-tour package
require("vue-tour/dist/vue-tour.css");
Vue.use(VueTour);

Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
});

import Notifications from "vue-notification";
Vue.use(Notifications);

// Vue.use('vue-shortkey', { prevent: ['input', 'textarea', 'v-text-field', 'v-textarea'] })
Vue.use(require("vue-shortkey"), {
  prevent: ["input", "textarea", "v-text-field", "v-textarea"],
});
import velocity from "velocity-animate";
Vue.use(Notifications, { velocity });

import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);

// cssVars()

Vue.use(BootstrapVue);

import vuetify from "@/plugins/vuetify"; // path to vuetify export

import VueHtmlToPaper from "vue-html-to-paper";
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css",
    "https://stackpath.bootstrapcdn.com/bootstrap/5.0.0-alpha2/css/bootstrap.min.css",
    "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-vue/2.19.0/bootstrap-vue-icons.min.css",
    "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-vue/2.19.0/bootstrap-vue.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    // '/print.css' //css stylings should be add to this file in public folder
  ],
};
Vue.use(VueHtmlToPaper, options);

//repeated data and methods imported here
Vue.mixin({
  data() {
    return {
      baseUrl: "https://piebaas.sarmadbs.com",
      // baseUrl: "http://192.168.1.12:3007",
      whenIsEmpty: "",
      vMoneyOptions: {
        decimal: ",",
        thousands: ",",
        precision: 0,
        suffix: "ریال",
        length: 16,
      },
      vMoneyOptions2: {
        decimal: ",",
        thousands: ",",
        precision: 0,
        suffix: "",
        length: 16,
      },
    };
  },
  methods: {
    validateEmail(email) {
      if (email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      } else return true;
    },
    toast(message, type) {
      this.$toast[type](message, {
        position: type == "success" ? "top-left" : "top-center",
        icon: false,
        closeButton: false,
        timeout: type == "success" ? 3000 : 10000,
      });
    },
  },
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  data: {
    // url: 'http://pm.sarmadbs.com/',
    // token: '6aad0847cc2ce0f4c4cb512c98be2a0a12c307ce'
  },
  router,
  store,
  template: "<App/>",
  components: {
    App,
  },
  vuetify,
  mounted() {
    // if (window.localStorage.api_key === undefined) {
    // window.location = '/#/pages/login'
    // this.router.go('/pages/login')
    // router.push({ name: 'Login' })
    //return
    // }
  },
});
